import {
  isOLDError,
  isRevertedWithoutReasonError,
  isTransactionReplacedError,
  transactionRejectedError,
  userRejectedRequestError,
  walletConnectionAlreadyPendingError,
} from './error-refinements';
import {
  asSwallowedError,
  asWarning,
  parseError,
  ParsedAsWarning,
  ParsedAsError,
  ParsedAsSwallowedError,
  UnparsedError,
  MaybeParsedError,
} from './parse-error-as';

const warningTransactionRejectedError = asWarning({
  is: transactionRejectedError.is,
  extractTitle: () => 'Transaction declined',
  extractMessage: () => 'You declined the transaction in your wallet.',
});

const swallowOLDError = asSwallowedError({
  is: isOLDError,
});

const swallowRevertedWithoutReasonError = asSwallowedError({
  is: isRevertedWithoutReasonError,
});

const swallowTransactionReplacedError = asSwallowedError({
  is: isTransactionReplacedError,
});

const warningUserRejectedRequestError = asSwallowedError({
  is: userRejectedRequestError,
})

const warningWalletConnectionAlreadyPendingError = asWarning({
  is: walletConnectionAlreadyPendingError,
  extractTitle: () => 'Request already pending',
  extractMessage: () => 'There is a pending request in your wallet. Take a look and try again.',
})

export const isWarning = <T>(result: MaybeParsedError<T>): result is ParsedAsWarning<T> => result._tag === 'Warning';
export const isError = <T>(result: MaybeParsedError<T>): result is ParsedAsError<T> => result._tag === 'Error';
export const isSwallowedError = <T>(result: MaybeParsedError<T>): result is ParsedAsSwallowedError<T> =>
  result._tag === 'SwallowedError';
export const isUnparsedError = <T>(result: MaybeParsedError<T>): result is UnparsedError => result._tag === 'Unparsed';

export const defaultErrorHandlers = [swallowOLDError, swallowRevertedWithoutReasonError];
export const defaultParseError = parseError(defaultErrorHandlers);

/**
 * default for user initiated transactions,
 * like deposit, borrow, etc.
 */
export const defaultUserInitiatedTransactionErrorHandlers = [
  swallowOLDError,
  swallowRevertedWithoutReasonError,
  swallowTransactionReplacedError,
  warningTransactionRejectedError,
];
export const parseUserInitiatedTransactionError = parseError(defaultUserInitiatedTransactionErrorHandlers);

export const parseWalletConnectionError = parseError(
  [
    warningUserRejectedRequestError,
    warningWalletConnectionAlreadyPendingError,
    ...defaultErrorHandlers
  ]
)
